'use client';

function getGreeting() {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good Morning';
  if (hour < 17) return 'Good Afternoon';
  return 'Good Evening';
}

/** Time-of-day greeting. Client-only so the hour matches the reader's clock. */
export function GreetingText({ firstName }: { firstName: string }) {
  return (
    <span suppressHydrationWarning>
      {getGreeting()}
      {firstName ? `, ${firstName}` : ''}!
    </span>
  );
}
